import PageComponent from './PageComponent'
import React from 'react'
import Faq from '../FAQ/Faq'
import './FormRow.scss'

const FaqsRow = ({title, faqs}) => {
    return (
        <PageComponent backgroundColor={'lightgray'}>
            <div className={'page__faqs-row'}>
                <h2 className="has-size-2" style={{marginBottom: '2rem'}}>
                    {title}
                </h2>
                {faqs.map((faq) => (
                    <Faq key={faq.id} question={faq.question} answer={faq.answer} />
                ))}
            </div>
        </PageComponent>
    )
}

export default FaqsRow
